import React from "react";

import { Main, Bold } from "../styles";

export default function Answer() {
  return (
    <Main>
      <Bold as="h1" style={{ fontSize: 22 }} color="#4B4B4B">
        Estado de conservação do veículo e equipamentos obrigatórios
      </Bold>
      <p>
        A - Cronotacógrafo - registrador inalterável de velocidade e tempo:
        obrigatório no transporte para veículos automotores de transporte de
        carga com PBT (peso bruto total) superior a 4,536 t e para veículos
        fabricados até 1990 com PBT acima de 19 t.;
      </p>
      <p>
        B - Pneus e rodas em bom estado/ verificar se está recauchutado e se a
        banda de rodagem está solta. Profundidade mínima do sulco dos pneus: 1,6
        mm. Ao menos um estepe para cada roda. Pneu(s) sobressalente(s), chave
        de rodas, macaco e triângulo de segurança.{" "}
      </p>
      <p>
        C - Dispositivos de controle: faróis alto e baixo, tacógrafo, lanternas
        de posição, indicador de mudança de direção (seta/pisca), luzes de
        freio, iluminação de placa traseira, pisca alerta e, luz de ré; 
        verificar funcionamento e se há trincamento (do sistema de
        iluminação).
      </p>
      <p>
        D - Películas refletivas (faixas refletivas) nas laterais e na traseira,
        além do para-choque traseiro.
      </p>
      <p>
        E - Equipamento (vaso de pressão ou carroçaria) em perfeitas condições,
        sem vazamento, sem ferrugens, sem trincas ou outros fatos que
        comprometam o transporte.
      </p>
      <p>
        F - Tanque de combustível: fechado com tampa original e sem vazamento. Verificar
        funcionamento do marcador de combustível.
      </p>
      <p>G - 5ª (quinta) roda (se houver): deve estar íntegra.</p>
      <p>H - Para-choque dianteiro/traseiro em boas condições.</p>
      <p>
        I - Cinto de segurança para a árvore de transmissão (Cinta protetora do
        eixo cardan): deve estar íntegra, em bom estado e fixada adequadamente.
      </p>
      <p>J - Fiação elétrica devidamente isolada e fixada.</p>
      <p>K - Para-lamas (dianteiros e traseiros) em boas condições.</p>
      <p>
        L - Espelhos retrovisores e limpadores de para-brisa em perfeito estado de funcionamento.
      </p>
      <p>
        M - Para brisa (dianteiro) em perfeito estado, sem trincas e fraturas na
        área crítica de visão do condutor (aquela situada a esquerda do veículo
        determinada por um retângulo de 50 cm de altura por 40 cm de largura,
        cujo eixo de simetria vertical é demarcado pela projeção da linha de
        centro do volante de direção, paralela à linha de centro do veículo,
        cuja base coincide com a linha tangente do ponto mais alto do volante) e
        em uma faixa periférica de 2,5 cm de largura das bordas externas do
        para-brisa.
      </p>
      <p>
        N - Limpador de para-brisa e lavador de para-brisa em perfeito estado de funcionamento.
      </p>
      <p>
        O - Pala interna de proteção contra o sol (pará-los) para o condutor.
      </p>
      <p>P - Buzina e sirene de marcha ré em perfeitas condições.</p>
      <p>Q - Protetores das rodas traseiras em perfeito estado.</p>
      <p>R - Cintos de segurança: para todos os ocupantes.</p>
      <p>
        S - Placas do veículo com as tarjetas em bom estado de visibilidade e
        legibilidade. A placa traseira deverá estar lacrada e com iluminação
        para o período noturno.
      </p>
      <p>
        T - Escapamento do veículo em perfeitas condições e com dispositivo
        corta-chamas.
      </p>
      <p>
        U - Pedais do veículo (acelerador, freio, embreagem) em perfeito estado
        sem vazamentos e ruídos no motor/suspensão.
      </p>
      <p>
        V - Cintas de amarração com catraca em boas condições. Não devem ter emendas ou com desgaste
        ou sem sistema de catraca para mantê-los tensionados evitando
        movimentação e instabilidade da carga. (Item obrigatório para envasado).
      </p>
      <p>
        X - Caminhões e carretas possui no mínimo duas amarrações na carga,
        sendo uma no meio e outra no final da carga. (Item obrigatório para
        envasado).
      </p>
      <p>
        Y - Borrachas nos degraus de acesso a cabine: verificar existência e
        condições de estado.
      </p>
    </Main>
  );
}
